import { render, staticRenderFns } from "./applyExam.vue?vue&type=template&id=b90cc774&scoped=true"
import script from "./applyExam.vue?vue&type=script&lang=js"
export * from "./applyExam.vue?vue&type=script&lang=js"
import style0 from "./applyExam.vue?vue&type=style&index=0&id=b90cc774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90cc774",
  null
  
)

export default component.exports